import React, { useMemo } from "react";
import ReactPlayer from "react-player";

// components
import VideoProgress from "./VideoProgress";
import ThumbnailVideo from "./ThumbnailVideo";

// props
import { MediaWrapProps, MediaProps } from "./types";

// utils
import { isEmpty } from "bodycodi/cmap/app/js/common";

const MediaWrap = ({ files, isDetail = false }: MediaWrapProps) => {
  const renderFiles = () => {
    const { videos, links, images } = useMemo(() => {
      const videos: any = [];
      const links: any = [];
      const images: any = [];

      files?.forEach((el: any) => {
        if (el.fileKindCode === "B") videos.push(el);
        if (el.fileKindCode === "C") links.push(el);
        if (el.fileKindCode === "A") images.push(el);
      });

      return { videos, links, images };
    }, [files]);

    return (
      <>
        {!isEmpty(videos) &&
          videos.map((file: any, i: number) => {
            return <Media file={file} key={i} />;
          })}
        {!isEmpty(links) &&
          links.map((file: any, i: number) => {
            return <Media file={file} key={i} />;
          })}
        {!isEmpty(images) &&
          images.map((file: any, i: number) => {
            return <Media file={file} key={i} />;
          })}
      </>
    );
  };

  const renderThumbnail = () => {
    if (!isEmpty(files)) {
      const video = files.find((item: any) => item.fileKindCode === "B");
      if (video) return <ThumbnailVideo file={video} />;

      const link = files.find((item: any) => item.fileKindCode === "C");
      return <Media file={link ? link : files[0]} />;
    }
  };

  if (isDetail) return <React.Fragment>{renderFiles()}</React.Fragment>;
  return <React.Fragment>{renderThumbnail()}</React.Fragment>;
};

const Media = ({ file }: MediaProps) => {
  return (
    <React.Fragment key={file.regDts}>
      {file.fileKindCode === "A" && <img className="content" src={file.fileUrl} />}
      {file.fileKindCode === "B" &&
        (file.videoConvertFlag === "C" ? (
          <video poster={file?.thumbNail} controls className="content" controlsList="nodownload">
            <source src={file.fileUrl} />
          </video>
        ) : (
          <VideoProgress />
        ))}
      {file.fileKindCode === "C" && (
        <div className="linkVideo">
          <ReactPlayer
            className="react-player"
            height="100%"
            width="100%"
            url={file.fileUrl}
            playing={false}
            controls={true}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default MediaWrap;
